import request from 'helper/NetworkLayer';

const callTakeControlAPI = async ({ userId }) => {
  window.analytics &&
    window.analytics.track('TAKE_CONTROL_API_REQUEST', {
      session_token: window.userSessionId,
      url: window.location.href,
      responseActionStatus: window.userSessionId
    });

  const response = await request(
    '/takecontrol',
    {
      method: 'POST',
      body: JSON.stringify({
        userId,
        sessionToken: window.userSessionId,
        actionType: 'takeControl'
      })
    },
    {
      removeApiEndpoint: true,
      dontAppendApiEndpointQS: true,
      doNotLogoutOn403: true
    }
  );

  if (response.ok) {
    const responseJSON = await response.json();
    window.analytics &&
      window.analytics.track('TAKE_CONTROL_API_RESPONSE', {
        session_token: window.userSessionId,
        url: window.location.href,
        responseActionStatus: responseJSON.actionStatus
      });
  }
};

export default callTakeControlAPI;
